import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Sites")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "border rounded p-4 mb-6"
}
const _hoisted_8 = { class: "row g-3 align-items-start" }
const _hoisted_9 = { class: "col-md-5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Site name", -1)
const _hoisted_11 = { class: "col-md-5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Slug", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, "Public URL uses this slug.", -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "form-label d-block" }, " ", -1)
const _hoisted_16 = {
  key: 2,
  class: "text-muted py-10 text-center"
}
const _hoisted_17 = {
  key: 3,
  class: "text-muted py-10 text-center"
}
const _hoisted_18 = {
  key: 4,
  class: "table-responsive"
}
const _hoisted_19 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_20 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createVNode("th", null, "Name"),
    /*#__PURE__*/_createVNode("th", null, "Slug"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Actions")
  ])
], -1)
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Edit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreate = !_ctx.showCreate))
        }, " New site ")
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.showCreate)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.name = $event)),
                  class: "form-control",
                  type: "text",
                  placeholder: "My store"
                }, null, 512), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.slug = $event)),
                  class: "form-control",
                  type: "text",
                  placeholder: "my-store"
                }, null, 512), [
                  [_vModelText, _ctx.form.slug]
                ]),
                _hoisted_13
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary w-100",
                  disabled: _ctx.creating,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createSite && _ctx.createSite(...args)))
                }, " Create ", 8, ["disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_16, "Loading sites..."))
        : (!_ctx.sites.length)
          ? (_openBlock(), _createBlock("div", _hoisted_17, " No sites yet. Create your first site to start building. "))
          : (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("table", _hoisted_19, [
                _hoisted_20,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: site.id
                    }, [
                      _createVNode("td", null, _toDisplayString(site.name), 1),
                      _createVNode("td", null, [
                        _createVNode("code", null, _toDisplayString(site.slug), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("span", {
                          class: ["badge", site.status === 'published' ? 'badge-light-success' : 'badge-light-warning']
                        }, _toDisplayString(site.status), 3)
                      ]),
                      _createVNode("td", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: `/sites/${site.id}/edit`,
                          class: "btn btn-sm btn-light-primary me-2"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (site.publicUrl)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: site.publicUrl,
                              class: "btn btn-sm btn-light",
                              target: "_blank",
                              rel: "noopener"
                            }, " View live ", 8, ["href"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
    ])
  ]))
}